import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAdmin: false,
    loggedIn: false
  },
  mutations: {
    setIsAdmin (state, payload) {
      state.isAdmin = payload.isAdmin;
    },
    setLoggedIn (state, payload) {
      state.loggedIn = payload.loggedIn;
    }
  },
  actions: {},
  modules: {},
});
